const CATEGORY_GROUPS = {
  SAFETY_FEATURE_CATEGORIES: 'safetyFeatureCategories',
  TEST_CATEGORIES: 'testCategories',
};

export default CATEGORY_GROUPS;
